import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import CarInspectionDrawer from "./modules/CarInspectionDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import { getAction } from '@api/manage';
import moment from 'moment';
export default {
  name: 'CarInspectionList',
  mixins: [JeecgListMixin],
  components: {
    CarInspectionDrawer: CarInspectionDrawer
  },
  props: {
    carId: {
      type: Number,
      default: null
    },
    carDetails: Boolean
  },
  data: function data() {
    return {
      permissionObj: {
        add: 'car:ea_asset_car_inspection:add',
        delete: 'car:ea_asset_car_inspection:delete',
        edit: 'car:ea_asset_car_inspection:edit',
        deleteBatch: 'car:ea_asset_car_inspection:deleteBatch'
      },
      pagePath: '/ea/asset/car/inspection',
      pageTitle: '车辆年检记录',
      userTree: [],
      //人员信息
      carList: [],
      carShow: true,
      autoLoadInit: false,
      detailsFlag: this.carDetails,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'card',
        colName: 'card',
        title: '车辆',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '送检人员',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'vehicleAdministrativeOffice',
        colName: 'vehicle_administrative_office',
        title: '车管所',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'inspectionDate',
        colName: 'inspection_date',
        title: '年检时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'nextDate',
        colName: 'next_date',
        title: '下次送检时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '年检状态',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'inspectionContent',
        colName: 'inspection_content',
        title: '年检内容',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'cost',
        colName: 'cost',
        title: '年检费用/元',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'inspectionStatus_dictText',
        colName: 'inspection_status',
        title: '年检情况',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'unQualified',
        colName: 'un_qualified',
        title: '不合格记录',
        align: 'center',
        sorter: false
      }, {
        dataIndex: 'remark',
        colName: 'remark',
        title: '备注',
        align: 'center',
        sorter: false
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      url: {
        carList: '/ea/asset/car/queryCarCards'
      },
      keys: [],
      roleList: '',
      addTime: '',
      buTime: '',
      siteName: '',
      queryParam: {
        column: 'create_time',
        order: 'desc'
      }
    };
  },
  created: function created() {
    this.queryUserTreeList();
    this.queryCarList();

    if (this.carDetails) {
      console.log('carDetails1111', this.carDetails);
      this.queryParam.carId = this.carId;
      this.carShow = !this.carDetails;
    }

    this.loadData();
  },
  computed: {},
  methods: {
    searchReset: function searchReset() {
      this.queryParam = {
        carId: this.carId,
        column: 'create_time',
        order: 'desc'
      };
      this.dates = {};
      this.loadData(1);
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = {
        carId: this.carId
      };
      this.loadData(1);
    },
    handleDetail: function handleDetail(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle + '详情';
      this.$refs.modalForm.disableSubmit = true;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = false;
      this.$refs.modalForm.activeKey = '1';
      this.$refs.modalForm.showInput = false;
      this.$refs.modalForm.carDisableStatus = true;
    },
    //查询
    searchQuery: function searchQuery() {
      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    queryCarList: function queryCarList() {
      var that = this;
      that.carList = [];
      getAction(that.url.carList).then(function (res) {
        if (res.success) {
          that.carList = res.result;
        }
      });
    },
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handleEdit: function handleEdit(record) {
      console.log('inspectionDate', record);
      this.$refs.modalForm.edit(record); //console.log(record)

      this.$refs.modalForm.title = '编辑：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = true;
      this.$refs.modalForm.showContact = true;
    },
    onDateInspectionDate: function onDateInspectionDate(value, dateArray) {
      this.queryParam.inspectionDateStart = dateArray[0] + ' 00:00:00';
      this.queryParam.inspectionDateEnd = dateArray[1] + ' 23:59:59';
    },
    onDateNextDate: function onDateNextDate(value, dateArray) {
      this.queryParam.nextDateStart = dateArray[0];
      this.queryParam.nextDateEnd = dateArray[1];
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};